// Compare machine IDs in order, then format the change with display names.
import { Change } from './change.ts';
import { getSimpleChange } from './getChange.ts';

export function getMachineChange(
    newIds: string[],
    oldIds: string[],
    machineNames: ReadonlyMap<string, string>,
): Change | null {
    const change = getSimpleChange(newIds.join(', '), oldIds.join(', '), ['Allowed machines']);
    if (!change) return null;

    const oldNames = oldIds.map(id => machineNames.get(id) ?? id).join(', ');
    const newNames = newIds.map(id => machineNames.get(id) ?? id).join(', ');
    const changeDescription = change.changeType === 'add' ? newNames
        : change.changeType === 'remove' ? oldNames
            : `${oldNames} → ${newNames}`;

    return {
        ...change,
        changeDescription,
    };
}
